import { useCallback, useMemo } from 'react';
import { useComponentsContext } from '../useComponentsContext';

interface UseComponentOverviewProps {
    onApplySuccess: () => void;
}

const useComponentOverview = ({ onApplySuccess }: UseComponentOverviewProps) => {
    const { isOpen, openModal, closeModal } = useComponentsContext();

    const onOpen = useCallback(() => {
        openModal(onApplySuccess);
    }, [openModal, onApplySuccess]);

    const onClose = useCallback(() => {
        closeModal();
    }, [closeModal]);

    const toggleComponentOverview = useMemo(() => (isOpen ? onClose : onOpen), [isOpen, onClose, onOpen]);

    return {
        toggleComponentOverview,
    };
};

export default useComponentOverview;
